// state
const state = {
    companyName: '',
    contactPersonName: '',
    contactPersonEmail: '',
    contactPersonPhone: '',
    driveSystem: '', 
    litersPerYear: null, //int       
}

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {
    setCompanyName(state, newValue) {
        state.companyName = newValue;
    },
    setContactPersonName(state, newValue) {
        state.contactPersonName = newValue;
    },
    setContactPersonEmail(state, newValue) {
        state.contactPersonEmail = newValue;
    },
    setContactPersonPhone(state, newValue) {
        state.contactPersonPhone = newValue;
    },
    setDriveSystem(state, newValue) {
        state.driveSystem = newValue;
    },
    setLitersPerYear(state, newValue) {
        state.litersPerYear = newValue;
    },    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}